<template>
  <div style="text-align: center; max-width:900px; margin-top: 50px">
    <section
      style="
  background-color: #ececec;
  padding-top: 50px;
  padding-bottom: 30px;
  margin-left: 20px;
  margin-right: 20px;
  border-radius:15px"
    >

        <h3>Últimos desafíos</h3>

        <div class="container">
          <div class="row" style="justify-content: center; display:block;">
            <div class="container">
              <div class="row" style="justify-content: center">
                <app-challenge
                  v-for="(challenge,index) in challenges"
                  :challenge="challenge"
                  v-bind:key="index"
                ></app-challenge>
              </div>
            </div>
          </div>
        </div>

    </section>
    <img
      src="public/images/site/paint-grey.svg"
      id="challenges"
      alt="Miles de proyectos"
      style=" margin-left: 20px;
margin-right: 20px;"
    />
  </div>
</template>


<script>
import Challenges from "../challenges/Challenge";
import { mapGetters } from "vuex";

export default {
  name: "latest-challenges",
  data: function() {
    return {
      perfil: "",
      challenges: ""
    };
  },
  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI"])
  },
  methods: {
    buscarDesafios() {
      var self = this;
      fetch(self.pathAPI + "challenge_alumno.php?cantidad_challenge=10")
        .then(response => response.json())
        .then(data => {
          self.challenges = data;
        });
    }
  },
  mounted: function() {
    this.buscarDesafios();
  },
  components: {
    appChallenge: Challenges
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/startPage/LatesChallenges.vue